import { useEffect, useRef, useState } from "react";
import { useOnboarding } from "../../../../hooks/useOnboarding";
import { FooterControlls } from "../../../../components/Onboarding/Template/FooterControlls/Index";
import { submitOnboarding } from "../../../../services/onboardingService";
import axios from "../../../../services/axios";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../constants/Index";
import { AlertModal } from "../../../../components/Modal/Alert/Index";
import { SimpleButtonClose } from "../../../../components/Modal/Contents/SimpleButtonClose/Index";
import { TitleModal } from "../../../../components/Modal/Contents/TitleModal/Index";
import { ButtonRedirect } from "../../../../components/Modal/Error/ButtonRedirect/Index";
import { calculateHectares } from "../../../../utils/geolib/calculateHectares";
import { FarmMapCard } from "./FarmMapCard";
import "./styles.css";

export function Summary() {
  const mainRef = useRef<HTMLElement>(null);
  const { payload } = useOnboarding();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [alertVisible, setAlertVisible] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const contentStyle = {
    width: '440px',
    height: '218px',
    background: '#FFFFFF',
    borderRadius: '20px',
    padding: '10px'
  } as React.CSSProperties;

  async function handleSubmit() {
    if (!payload) return false;

    setIsSubmitting(true);
    try {
      const processedPayload = await submitOnboarding(payload);

      await axios.post("/onboarding", processedPayload);
      localStorage.removeItem(Constants.LOCALSTORAGE_PAYLOAD);
      navigate(Constants.PADDOCKS_MAP);
      return true;
    } catch (error: any) {
      console.log(error.response);
      if (error.response?.data?.errors_fields?.[0]?.field === "farm_initials_key") {
        setError('Sigla na tela de fazenda já cadastrada!');
      } else {
        setError(error.response?.data?.msg || 'Erro ao finalizar onboarding');
      }
      setAlertVisible(true);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, []);

  return (
    <>
      <AlertModal visible={alertVisible} contentStyle={contentStyle}>
        <SimpleButtonClose onClick={() => setAlertVisible(false)} />
        <div className="createuser__alertModalBody">
          <TitleModal>{error}</TitleModal>
        </div>
        <ButtonRedirect onClick={() => setAlertVisible(false)}>VOLTAR</ButtonRedirect>
      </AlertModal>

      <main ref={mainRef as any}>
        <section className="summary__container">
          <div>
            <h2 className="summary__title">Perfis Criados ({payload.users.length})</h2>
            {/* Perfis */}
            {payload?.users && payload.users.length > 0 && (
              <div className="summary__section">
                <ul>
                  {payload.users.map((user, index) => (
                    <li key={index}>
                      <strong>{user.name}</strong>
                      {user.phone && <span> - {user.phone}</span>}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Mapas das Fazendas */}
            {payload?.farms && payload.farms.length > 0 && (
              <div style={{ marginTop: 30 }}>
                <h2 className="summary__title">Fazendas, Retiros e Pastos ({payload.farms.length})</h2>
                {payload.farms.map((farm, index) => (
                  <div key={farm.uuid || index}>
                    <FarmMapCard
                      farm={farm}
                      areas={payload.areas || []}
                      microAreas={payload.micro_areas || []}
                    />
                    {index < payload.farms.length - 1 && (
                      <div className="summary__farm-divider" />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <footer>
        <FooterControlls
          nextStepEvent={handleSubmit}
          backStepEvent={async () => true}
        />
      </footer>
    </>
  );
}
